/**
 * Current user state holder.
 *
 * Populated by AuthProvider once `/api/v1/me` resolves. Consumed by code paths
 * that need the authenticated user's identity outside the React tree (Redux
 * thunks, axios interceptors), where useAuth() is not available.
 */

let currentUserEmail: string | null = null;

export function setCurrentUserEmail(email: string | null): void {
  currentUserEmail = email;
}

export function getCurrentUserEmail(): string | null {
  return currentUserEmail;
}
